import { capitalize } from 'lodash';
import { useMemo } from 'react';

import { type CustomFieldType } from '@air/api/types';

import { customFieldIconMap } from '~/constants/customFieldIconMap';

type CustomFieldTypeLabelProps = {
  fieldTypeId: string;
  fieldTypes: CustomFieldType[];
};

export const CustomFieldTypeLabel = ({ fieldTypeId, fieldTypes }: CustomFieldTypeLabelProps) => {
  const fieldType = useMemo(() => {
    return fieldTypes.find((ft) => ft.id === fieldTypeId);
  }, [fieldTypeId, fieldTypes]);

  if (!fieldType) {
    return null;
  }
  const Icon = customFieldIconMap[fieldType.title];

  return (
    <div className="flex items-center gap-2">
      {Icon && <Icon className="size-4 ads:text-icon-default text-gray-10" />}
      <div className="grow">
        <p className="ads:text-primary text-14 text-gray-12">{capitalize(fieldType.title)}</p>
      </div>
    </div>
  );
};
